export default function() {
  controller('drawer', self => {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    self.on('click', function () {
      $(this).closest('.drawer__category-item').find('.drawer__category-holder').empty();
    });

    function toggleDrawer() {
      $('.js-drawer-btn').on('click', function () {
        if (!$(this).hasClass('active')) {
          if(iOS) { 
            $('body').css({
              top: $(document).scrollTop()* -1,
              position: 'fixed',
              width: '100%'
            });
          }
          $(this).addClass('active');
          $('.js-drawer-collapse').slideDown('slow');
          $('.js-drawer-bg').addClass('show');
          $('body').addClass('locked');
        } else {
          $(this).removeClass('active');
          $('.js-drawer-collapse').slideUp('slow', () => {
            if(iOS) { 
              var offset_b = $('body').offset().top* -1;    
              $('body').removeAttr('style');    
              $(window).scrollTop(offset_b);
            }
          });
          $('.js-drawer-bg').removeClass('show');
          $('body').removeClass('locked');
        }
        
      });
    }
    toggleDrawer();

    function clickBg() {
      $('.js-drawer-bg').on('click', function() {
        $('.js-drawer-btn').removeClass('active');
        $('.js-drawer-collapse').slideUp('slow');
        $('.js-drawer-bg').removeClass('show');
        $('body').removeClass('locked');
      });
    }
    clickBg();

  });
}
